import React from 'react';
import './footer.css';

const Footer = () => {
  return (
    <div className="gpt3__footer section__padding" id="contact">
      <div className="gpt3__footer-heading">
        <h1 className="gradient__text">Lake Champlain Physical Therapy, PLLC</h1>
      </div>

      <div className="gpt3__footer-btn">
        <p>Call (518) 597-4678</p>
      </div>

      <div className="gpt3__footer-links">
        <div className="gpt3__footer-links_logo">
          <h3>LCPT</h3>
          <p>Personalized physical therapy in Crown Point, New York.</p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Services</h4>
          <p>Back and neck pain</p>
          <p>Joint pain treatment</p>
          <p>Post-surgical rehab</p>
          <p>Injury management</p>
        </div>
        <div className="gpt3__footer-links_div">
          <h4>Get in Touch</h4>
          <p>2786 Main Street</p>
          <p>Crown Point, NY 12928</p>
          <p>(518) 597-4678</p>
          <p>Fax: (844) 597-4678</p>
        </div>
      </div>
      <div className="gpt3__footer-copyright">
        <p>© 2026 Lake Champlain Physical Therapy, PLLC. All rights reserved.</p>
      </div>
    </div>
  )
}

export default Footer
